import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { class: "container centered" }
const _hoisted_3 = {
  key: 0,
  class: "row"
}
const _hoisted_4 = { style: {"margin":"60px auto"} }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h5", { class: "lh32 fs24 fw600" }, "カレンダー連携を解除", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.rm.userInfo?.email)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/logo/logo140.png`),
                height: "60"
              }, null, 8, _hoisted_5)
            ]),
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _createElementVNode("p", null, [
              _createTextVNode(" このアカウント(" + _toDisplayString(_ctx.rm.userInfo.email) + ")に連携している外部カレンダーを解除します。", 1),
              _hoisted_10,
              _createTextVNode("取り消しができませんので、アカウントにお間違いがないことをご確認ください。 ")
            ]),
            _hoisted_11,
            _createElementVNode("div", {
              class: "mc fs16 fw600 dblueBg rad8 pad15 pointer hoverGreyBg",
              style: {"width":"120px"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.disconnectCalendar && _ctx.disconnectCalendar(...args)))
            }, " 解除 "),
            _hoisted_12,
            _hoisted_13
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}